import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import $ from 'jquery';
import axios from 'axios';
import { isEmpty, } from 'lodash';

import {
    awaitDelay, checkIfUserIsMaster, dataTableLanguaje, buttonProcessGet, globalSettings, isUndNullEmp, languageObjGet, LoadingSection, processEvaluateGet, responseGet,
    sendMessageCloseCurrentWindowAsync, styles
} from '../../helpers/settings';
import RoleAddEditDetails from './RoleAddEditDetails';
import { condominiumBoardRoleModelGet } from '../../models/condominiumBoard/role';
import useAuth from '../../controllers/users/useAuth';
import Menu from '../main/Menu';
import Swal from 'sweetalert2';
import BuildingHeader from '../buildings/BuildingHeader';
import { buildingsByUserGetAsync } from '../../controllers/apartments/apartmentUsers';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';

const currentMethod = 'CondominiumBoardRoles';

const { app, colors, collections: dbColle, icons, images, labels, messages, react, } = globalSettings;
const { backend, } = app;
const { properties: dbProps, } = dbColle;
const { firebase, sweetAlert2, } = react;
const { operators: dbOpera, } = firebase;

export default function CondominiumBoardRoles({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region otehrs
    let result;
    let dataObj = {};
    let headerObj = {};
    const auth = useAuth();
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    const [processType, setProcessType] = useState(0);
    const [btnAddDisbled, setBtnAddDisabled] = useState(true);
    const [showLoading, setShowLoading] = useState({ buildings: true, condominiumBoardRoles: true, });
    //const [showData, setShowData] = useState(false);
    //#endregion otehrs

    //#region buildings
    const buildingsId = 'buildingsId';
    const [building, setBuilding] = useState({});
    const [buildings, setBuildings] = useState([]);
    //#endregion buildings

    //#region condominum board roles
    let condominiumBoardRoles = [];
    //const btnCondominiumBoardRoleDeleteId = 'btnCondominiumBoardRoleDelete';
    const dtCondominiumBoardRolesId = 'dtCondominiumBoardRoles';
    const [condominiumBoardRole, setCondominiumBoardRole] = useState({});
    const [condominiumBoardRolesShowModal, setCondominiumBoardRolesShowModal] = useState(false);
    const [dtCondominiumBoradRolesRowIndex, setDtCondominiumBoradRolesRowIndex] = useState(0);
    const [btnCondominiumBoardRolesSyncDisabled, setBtnCondominiumBoardRolesSyncDisabled] = useState(true);
    //#endregion condominium board roles

    //#region others
    const controls = {
        buttons: {
            // create: {
            //     className: 'btn btn-outline-success float-right btn-sm',
            //     id: 'btnCreate',
            // },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            condominiumBoardRoles: {
                buttons: {
                    create: {
                        className: 'btn btn-outline-success float-right btn-sm',
                        id: 'btnDtCondominiumBoardRolesCreate',
                    },
                },
                icons: {
                    create: {
                        id: 'iconDtCondominiumBoardRolesCreate',
                        className: icons?.plusCircle,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtCondominiumBoardRolesId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtCondominiumBoardRolesId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    create: {
                        id: 'spDtCondominiumBoardRolesCreate',
                        className: '',
                    }
                },
            },
        },
        icons: {
            // create: {
            //     id: 'iconCreate',
            //     className: icons?.plusCircle,
            // },
        },
        inputs: {
            // email: {
            //     id: 'inputEmail',
            // },
            // password: {
            //     id: 'inputPassword',
            // },
        },
        spinners: {
            // create: {
            //     id: 'spCreate',
            //     className: '',
            // }
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region condominum board roles (methods)
    const dataTableCondominiumBoardRolesSet = ({ subMethod = '', }) => {
        const currentMethod = 'dataTableCondominiumBoardRolesSet';
        let response = responseGet();
        try {
            $(`#${dtCondominiumBoardRolesId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.description?.[languageObj?.id], width: '85%', },
                    { title: labels?.hierarchy?.[languageObj?.id], width: '10%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[1, 'asc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtCondominiumBoardRolesId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const condominiumBoardRolesGetAsync = async ({ e = {}, processType_ = 0, subMethod = '', }) => {
        const currentMethod = 'condominiumBoardRolesGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            processType_ = processType_ === 's' || processType_ === 'b' ? 1 : processType_;

            setShowLoading({ buildings: false, condominiumBoardRoles: true, });

            $(`#${dtCondominiumBoardRolesId}`)?.DataTable()?.rows().clear()?.draw(true);
            //setShowData(false);

            //#region variables initialize
            let idsEditLocal = false;
            let isDeleteLocal = false;
            let buildingLocal = buildingModelGet({});

            const buildingIdLocal = $(`#${buildingsId}`)?.val();

            setBuilding({});
            setBtnAddDisabled(true);
            condominiumBoardRoles = [];
            setProcessType(processType_);
            setBtnCondominiumBoardRolesSyncDisabled(true);
            //#endregion variables initialize

            //#region get condominium board roles
            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                buildingLocal = buildings.find(({ id }) => id === buildingIdLocal);
                if (!isUndNullEmp({ data: buildingLocal, subMethod: currentMethod, })?.result) {
                    headerObj = {
                        headers: {
                            authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                        },
                    };

                    dataObj = {
                        conditionals: [
                            { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: buildingIdLocal, },
                        ],
                        ordersBy: [
                            { field: dbProps?.hierarchy, value: 'asc', },
                        ],
                        buildingId: buildingIdLocal,
                        languageId: languageObj?.id,
                        url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCondominiumBoardRoles}/`,
                    };

                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );

                    response = result?.data;

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ buildings: false, condominiumBoardRoles: false, });
                        //setShowData(false);
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    const rolesLocal = response?.result || [];

                    if (!isUndNullEmp({ data: rolesLocal, subMethod: currentMethod, })?.result && rolesLocal?.length > 0) {
                        rolesLocal?.forEach((detail) => {
                            condominiumBoardRoles.push([
                                detail?.description,
                                detail?.hierarchy || 0,
                                buttonProcessGet({
                                    id: detail?.id,
                                    description: detail?.description,
                                    showDetails: true,
                                    labelDetails: labels?.detail?.[languageObj?.id],
                                    enabledDetails: true,
                                    showEdit: true,
                                    labelEdit: labels?.edit?.[languageObj?.id],
                                    enabledEdit: processEvaluateGet({
                                        object: detail,
                                        property: labels?.process?.en?.toLowerCase(),
                                        process: labels?.edit?.en?.toLowerCase(),
                                        subMethod: currentMethod,
                                    })?.result,
                                    showDelete: true,
                                    labelDelete: labels?.delete?.[languageObj?.id],
                                    enabledDelete: processEvaluateGet({
                                        object: detail,
                                        property: labels?.process?.en?.toLowerCase(),
                                        process: labels?.delete?.en?.toLowerCase(),
                                        subMethod: currentMethod,
                                    })?.result,
                                    processButtons: [],
                                    subMethod: currentMethod,
                                })?.result,
                            ]);
                        });

                        //#region check if add register is enabled
                        idsEditLocal = processEvaluateGet({
                            object: rolesLocal?.[0],
                            property: labels?.process?.en?.toLowerCase(),
                            process: labels?.edit?.en?.toLowerCase(),
                            subMethod: currentMethod,
                        })?.result;
                        isDeleteLocal = processEvaluateGet({
                            object: rolesLocal[0],
                            property: labels?.process?.en?.toLowerCase(),
                            process: labels?.edit?.en?.toLowerCase(),
                            subMethod: currentMethod,
                        })?.result;
                        //#endregion check if add register is enabled
                    } else {
                        //#region check if add register is enabled
                        idsEditLocal = processEvaluateGet({
                            object: buildingLocal,
                            property: labels?.process?.en?.toLowerCase(),
                            process: labels?.edit?.en?.toLowerCase(),
                            subMethod: currentMethod,
                        })?.result;

                        isDeleteLocal = idsEditLocal;
                        //#endregion check if add register is enabled
                    }
                }

                setBuilding(buildingLocal);
                setBtnCondominiumBoardRolesSyncDisabled(false);
                setBtnAddDisabled(!(idsEditLocal && isDeleteLocal));
            }
            //#endregion get condominium board roles

            //#region dataTable set / set data on datatables
            // response = dataTablesSet();
            // if (!response?.isSuccess || response?.isWarning) {
            //     setShowLoading({ buildings: false, condominiumBoardRoles: false, });
            //     //setShowData(false);
            //     await sendMessageCloseCurrentWindowAsync({
            //         msgType: response?.msgType,
            //         msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            //         closeWindow: false,
            //         urlGoTo: response?.urlGoTo,
            //         auth: auth,
            //         isLogout: false,
            //         languageId: languageObj?.id,
            //         subMethod: currentMethod,
            //     });
            //     return;
            // }

            $(`#${dtCondominiumBoardRolesId}`)?.DataTable()?.rows?.add(condominiumBoardRoles)?.draw();
            //#endregion dataTable set / set data on datatables

            setShowLoading({ buildings: false, condominiumBoardRoles: false, });
            //setShowData(true);
        } catch (ex) {
            setShowLoading({ buildings: false, condominiumBoardRoles: false, });
            //setShowData(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const condominiumBoardRoleAddEditGetAsync = async ({ e = {}, id = '', description = '', rowIndex = 0, processType_ = 0, subMethod = '', }) => {
        const currentMethod = 'condominiumBoardRoleAddEditGetAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            if (processType_ === 0) {
                controlsStatusSet({ processType: 1, subMethod: currentMethod, });
            } else if (processType_ > 0) {
                setShowLoading({ buildings: false, condominiumBoardRoles: true, });
            }

            //#region variables initialize
            setProcessType(processType_);
            setCondominiumBoardRole({});
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#endregion variables initialize

            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                //#region condominiumBoardRole get
                if (processType_ === 0) {
                    await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond });
                    setCondominiumBoardRole(
                        condominiumBoardRoleModelGet({
                            buildingId: building?.id,
                            userId: auth?.user?.uid,
                        })
                    );
                } else {
                    //#region condominiumBoardRole get
                    headerObj = {
                        headers: {
                            authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                            languageId: languageObj?.id,
                        },
                        url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCondominiumBoardRoles}/${id}`,
                    };

                    result = await axios?.get(
                        headerObj?.url,
                        headerObj,
                    );

                    response = result?.data;

                    if (!response?.isSuccess || response?.isWarning) {
                        if (processType_ === 0) {
                            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                        } else if (processType_ > 0) {
                            setShowLoading({ buildings: false, condominiumBoardRoles: false, });
                        }
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    const condominiumBoardRole = response?.result;
                    setCondominiumBoardRole(condominiumBoardRole);
                    //#endregion condominiumBoardRole get
                }
                //#endregion condominiumBoardRole get
            } else {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 0,
                    msgText: messages?.youMustSelectBuilding?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            //#region data set
            setProcessType(processType_);
            setDtCondominiumBoradRolesRowIndex(rowIndex);
            setCondominiumBoardRolesShowModal(true);
            //#endregion data set

            if (processType_ === 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else if (processType_ > 0) {
                setShowLoading({ buildings: false, condominiumBoardRoles: false, });
            }
        } catch (ex) {
            if (processType_ === 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else if (processType_ > 0) {
                setShowLoading({ buildings: false, condominiumBoardRoles: false, });
            }
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    //#region old code
    // const localCondominiumBoardRoleDeleteGet = (id = '', description = '', rowIndex = 0) => {
    //     let response = responseGet();
    //     try {
    //         setDtCondominiumBoradRolesRowIndex(rowIndex);
    //         setCondominiumBoardRole({});
    //         setCondominiumBoardRole({ ...condominiumBoardRole, id, description, });
    //         $(`#${btnCondominiumBoardRoleDeleteId}`)?.trigger('click');
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localCondominiumBoardRoleDeleteGet<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
    //     }
    // }
    //#endregion old code

    //#region old code
    // const localCondominiumBoardRoleDeleteGetAsync = async (e = {}) => {
    //     let response = responseGet();
    //     try {
    //         e.preventDefault();
    //         sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

    //         //#region show alert to delete

    //         let msgText = `${labels?.role?.[languageObj?.id]}: <b>${condominiumBoardRole.description}</b><br/>`;
    //         msgText += `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`;

    //         const swalProperties = {
    //             icon: sweetAlert2?.icons?.warning,
    //             title: messages?.areYouSureDeleteThis?.[languageObj?.id],
    //             html: msgText,
    //             timer: null,
    //             confirmButtonColor: colors?.warningColorExp,
    //             confirmButtonText: labels?.yes?.[languageObj?.id],
    //             showCancelButton: true,
    //             cancelButtonColor: colors?.successColorExp,
    //             cancelButtonText: labels?.no?.[languageObj?.id],
    //             didOpen: () => {
    //                 Swal.hideLoading();
    //             },
    //         };

    //         const { isConfirmed, } = await Swal.fire(swalProperties);

    //         //#endregion show alert to delete

    //         //#region delete data
    //         if (isConfirmed) {
    //             localCondominiumBoardRoleDeletePostAsync();
    //         }
    //         //#endregion delete data
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localCondominiumBoardRoleDeleteGetAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //     }
    // }
    //#endregion old code

    //#region old code
    // const localCondominiumBoardRoleDeletePostAsync = async () => {
    //     let response = responseGet();
    //     try {
    //         sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

    //         //#region delete condominiumBoardRole

    //         headerObj = {
    //             headers: {
    //                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //             },
    //         };

    //         //result = await axios.delete(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlCondominiumBoardRoles}/${condominiumBoardRole.id}`, headerObj);
    //         result = await axios.delete(`${backend?.url}${backend?.urlApiV1}${backend?.urlCondominiumBoardRoles}/${condominiumBoardRole.id}`, headerObj);
    //         response = result.data;

    //         if (!response?.isSuccess || response?.isWarning) {
    //             await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //             return;
    //         }

    //         //#endregion delete condominiumBoardRole

    //         //#region delete condominiumBoardRole (dataTable)

    //         $(`#${dtCondominiumBoardRolesId}`)?.DataTable()?.row(dtCondominiumBoradRolesRowIndex)?.remove()?.draw(true);

    //         //#endregion delete condominiumBoardRole (dataTable)

    //         setCondominiumBoardRole({});
    //         setDtCondominiumBoradRolesRowIndex(0);

    //         sendMessage(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localCondominiumBoardRoleDeletePostAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //     }
    // }
    //#endregion old code

    const condominiumBoardRoleDeleteAsync = async ({ id = '', description = '', rowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'condominiumBoardRoleDeleteAsync';
        let response = responseGet();
        try {
            //#region show message
            let msgTextObj = {
                one: `${labels?.role?.[languageObj?.id]}: <b>${description}</b><br/>`,
                two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            let swalProperties = {
                icon: sweetAlert2?.icons?.warning, //messages?.sweetAlert2?.icons?.warning,
                title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: msgTextObj?.one,
                            showConfirmButton: false,
                        });

                        //#region delete condominiumBoardRole
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                languageId: languageObj?.id,
                            },
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlCondominiumBoardRoles}/${id}`,
                        };

                        result = await axios.delete(
                            headerObj?.url,
                            headerObj,
                        );

                        response = result?.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion delete condominiumBoardRole

                        //#region delete condominiumBoardRole (dataTable)
                        $(`#${dtCondominiumBoardRolesId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
                        //#endregion delete condominiumBoardRole (dataTable)

                        setCondominiumBoardRole({});
                        setDtCondominiumBoradRolesRowIndex(0);

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }
    //#endregion condominum board roles (methods)

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ buildings: true, condominiumBoardRoles: true, });
            //setShowData(false);

            //#region variables initialize
            setBuildings([]);
            condominiumBoardRoles = [];
            //#endregion variables initialize

            //#region dataTables set
            response = dataTablesSet({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, condominiumBoardRoles: false, });
                //setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion dataTables set

            //#region buildings get
            response = await buildingsByUserGetAsync({
                userRole: userRole,
                auth: auth,
                urlGoTo: backend?.urlHome,
                languageId: languageObj,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, condominiumBoardRoles: false, });
                //setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            if (!isUndNullEmp({ data: response?.result?.buildings, subMethod: currentMethod, })?.result && response?.result?.buildings?.length > 0) {
                setBuildings(response?.result?.buildings);
            }
            //#endregion buildings get

            setShowLoading({ buildings: false, condominiumBoardRoles: false, });
            //setShowData(true);
        } catch (ex) {
            setShowLoading({ buildings: false, condominiumBoardRoles: false, });
            //setShowData(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesSet = ({ subMethod = '', }) => {
        const currentMethod = 'dataTablesSet';
        let response = responseGet();
        try {
            response = dataTableCondominiumBoardRolesSet({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = queryCodeSet({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const queryCodeSet = ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSet';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region methods
            $(`#${dtCondominiumBoardRolesId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtCondominiumBoardRolesId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'details':
                            condominiumBoardRoleAddEditGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType_: 2, subMethod: currentMethod, });
                            break;
                        case 'edit':
                            condominiumBoardRoleAddEditGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType_: 1, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            condominiumBoardRoleDeleteAsync({ id: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.dataTables?.condominiumBoardRoles?.icons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.condominiumBoardRoles?.buttons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.condominiumBoardRoles?.spinners?.create?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.condominiumBoardRoles?.icons?.create?.id}`)?.addClass(controls?.dataTables?.condominiumBoardRoles?.icons?.create.className);
                    $(`#${controls?.dataTables?.condominiumBoardRoles?.buttons?.create?.id}`)?.addClass(controls?.dataTables?.condominiumBoardRoles?.buttons?.create?.className);
                    $(`#${controls?.dataTables?.condominiumBoardRoles?.spinners?.create?.id}`)?.addClass(controls?.dataTables?.condominiumBoardRoles?.spinners?.create.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.dataTables?.condominiumBoardRoles?.icons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.condominiumBoardRoles?.spinners?.create?.id}`)?.addClass(`${react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region old code
            // $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.password?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.checkBox?.remenberMe?.id}`).attr('disabled', (processType !== 0));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : messages?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.condominiumBoardRoles?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.condominiumBoardRoles?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.dataTables?.condominiumBoardRoles?.buttons?.create?.id}`)?.addClass(`${react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='condominiumBoard' process='condominiumBoardRoles' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <section className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.condominiumBoard?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.roles?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            <div className='col-12'>

                                {/*buildings*/}
                                <BuildingHeader buildingsId={buildingsId}
                                    building={building}
                                    buildings={buildings}
                                    btnSyncDisabled={btnCondominiumBoardRolesSyncDisabled}
                                    methodGetAsync={condominiumBoardRolesGetAsync}
                                    processType={0}
                                    headerSectionValues={{}}
                                    showLoading={showLoading?.buildings}
                                    languageObj={languageObj}
                                />

                                {/*condominium board roles*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.condominiumBoardRoles}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.roles?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.condominiumBoardRoles}>
                                            </img> - {labels?.roles?.[languageObj?.id]}
                                        </h6>

                                        <div className='card-tools'>
                                            <button type='button'
                                                className='btn btn-tool'
                                                data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div> {/*card header*/}

                                    <div className='card-body'>

                                        <div className='row'>
                                            {/* {!showLoading ? */}
                                            <div className='col-md-12'>
                                                {/* {showData ? */}
                                                {/* <div> */}
                                                <button id={controls?.dataTables?.condominiumBoardRoles?.buttons?.create?.id}
                                                    className={controls?.dataTables?.condominiumBoardRoles?.buttons?.create?.className}
                                                    //className='btn btn-outline-success float-right btn-sm'
                                                    disabled={isEmpty(building) || btnAddDisbled}
                                                    onClick={(e) => condominiumBoardRoleAddEditGetAsync({ e: e, id: '', description: '', rowIndex: 0, processType_: 0, subMethod: 'btn - addCondominiumBoardRole', })}
                                                    tooltip='tooltip'
                                                    title={labels?.add?.[languageObj?.id]}>
                                                    <i id={controls?.dataTables?.condominiumBoardRoles?.icons?.create?.id} className={controls?.dataTables?.condominiumBoardRoles?.icons?.create?.className} /> <span id={controls?.dataTables?.condominiumBoardRoles?.spinners?.create?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                {/* <button className='btn btn-outline-danger float-right btn-sm mx-1'
                                                    disabled={isEmpty(building)}
                                                    hidden
                                                    id={btnCondominiumBoardRoleDeleteId}
                                                    onClick={(e) => localCondominiumBoardRoleDeleteGetAsync(e)}
                                                    tooltip='tooltip'
                                                    title={labels?.delete?.[languageObj?.id]}><i className={icons?.trash}></i></button> */}
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtCondominiumBoardRolesId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                                {/* </div> */}
                                                {/* : */}
                                                {/* <div></div> */}
                                                {/* } */}
                                            </div>
                                            {/* :
                                                <CssfxLoading type={messages?.CssfxLoading?.circularProgress}
                                                    width={40}
                                                    height={40}
                                                    color={colors?.infoColorExp}
                                                    msgText={messages?.processing?.[languageObj?.id]}
                                                    msgOrientation='text-center'
                                                    msgTextMuted={true} /> */}
                                            {/* } */}
                                        </div>

                                    </div>
                                </div>

                            </div>{/*col*/}
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}
                </section>{/* /.content */}

            </div>

            {condominiumBoardRolesShowModal ?
                <RoleAddEditDetails $={$}
                    auth={auth}
                    userRole={userRole}
                    building={building}
                    condominiumBoardRole={condominiumBoardRole}
                    setCondominiumBoardRole={setCondominiumBoardRole}
                    dtId={dtCondominiumBoardRolesId}
                    dtRowIndex={dtCondominiumBoradRolesRowIndex}
                    showModal={condominiumBoardRolesShowModal}
                    setShowModal={setCondominiumBoardRolesShowModal}
                    processType={processType}
                    languageObj={languageObj} />
                :
                <></>
            }
        </div>
    );
}